import styled from 'styled-components';

export const OnboardingBlock = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  min-height: 100dvh;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  text-align: center;
  padding: 20px;
  background: var(--body-bg);
  color: var(--text-main);

  label {
    color: var(--text-main);
  }

  .brand_logo {
    display: block;
    width: min(148px, 55vw);
    margin: 0 auto 28px;

    @media (min-width: 768px) {
      width: 168px;
      margin: 0 auto 32px;
    }

    @media (min-width: 992px) {
      max-width: 200px;
      position: absolute;
      left: 24px;
      top: 24px;
      margin: 0;
    }

    img {
      display: block;
      max-width: 100%;
      height: auto;
    }
  }
`;

export const FormCol = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;

  .form-content {
    width: 100%;
    max-width: 450px;
    margin: 0 auto;
  }
`;
